// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"YA-z","smallCardRow":"ZA-z","largeCardRow":"_A-z","productSearchRow":"aB-z","curatedRow":"bB-z"};